<button *ngIf="!appMain.configActive" id="filterButton" aria-label="Filter Data" href="javascript:;" pTooltip="Filter" tooltipPosition="top"
    class="layout-config-button" (click)="toggleFilterPanel()" style="cursor: pointer;color: #1b5786 !important;background-color: #fff; height:32px; width: 32px;" pButton
    icon="pi pi-filter">
</button>
<p-sidebar [(visible)]="showFilter" position="right" [baseZIndex]="1000" (onHide)="closeFilterSidebar()"
    id="cozmosFilterPanel">
    <div class="sidebar-title">
        <h5>Filters</h5>
    </div>
    <div class="cozmos-filter-panel">
        <p-dropdown *ngIf="showFilterTemplate && router?.url?.includes('manual-email-template')"
            (onChange)="onChangeGetFilterTemplateDetails($event)" [options]="templateList" placeholder="Select Template"
            [group]="true" optionLabel="template_name" [(ngModel)]="templateData" [showClear]="true">
            <ng-template let-group pTemplate="group">
                <div class="flex align-items-center">
                    <span>{{group.name}}</span>
                </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <div class="flex align-items-center justify-content-between">
                    <span class="w-11">{{item?.template_name}}</span> <span> <button *ngIf="showDeleteTemplate"
                            (click)="onClickDeleteTemplate(item?.id)" pTooltip="Remove" pButton pRipple type="button"
                            icon="pi pi-times"
                            class="p-button-rounded p-button-text p-button-danger h-1rem"></button></span>
                </div>
            </ng-template>
        </p-dropdown>
        <div class="sidebar-header">
            <span>
                <button pButton *ngIf="showUpdate && showSaveFilterTemplate" [disabled]="!hasFilterValues()"
                    (click)="saveTemplate.toggle($event)" label="UPDATE"
                    class="sidebar-button cozmos-secondary-button"></button>
                <!-- <button pButton *ngIf="showFilterTemplate && showSaveFilterTemplate && !showUpdate" label="SAVE"
                    [disabled]="!hasFilterValues()" (click)="saveTemplate.toggle($event)"
                    class="sidebar-button cozmos-secondary-button"></button> -->
                <button pButton label="APPLY" class="sidebar-button cozmos-primary-button"
                    [disabled]="!hasFilterValues()" (click)="applyFilterSidebar()"></button>
                <button pButton label="RESET" class="sidebar-button cozmos-secondary-button"
                    (click)="restFilterSidebar()"></button>
            </span>
        </div>
        <p-overlayPanel #saveTemplate styleClass="w-30rem">
            <ng-template pTemplate>
                <h5 class="p-2 pb-1 mb-0 overlay-header">Save Template</h5>
                <form [formGroup]="saveTemplateForm">
                    <div class="fluid p-2">
                        <p-radioButton inputId="1" class="ml-2" name="is_shared" [value]=true
                            formControlName="is_shared" label="Public"></p-radioButton>
                        <p-radioButton inputId="0" class="ml-2" name="is_shared" [value]=false
                            formControlName="is_shared" label="Private"></p-radioButton>
                        <small
                            *ngIf="saveTemplateForm.get('is_shared').touched && saveTemplateForm.get('is_shared')?.invalid"
                            class="p-error">Please Select Whether you want to Keep this Template Private or
                            Public</small>
                        <div class="field col-12 mb-0 pb-0 pl-0 pr-0">
                            <input id="template_name" placeholder="Enter Unique Template Name" pInputText type="text"
                                formControlName="template_name" minlength="3" maxlength="30"
                                class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                        </div>
                        <small
                            *ngIf="saveTemplateForm.get('template_name').touched && saveTemplateForm.get('template_name')?.invalid && saveTemplateForm.get('template_name')?.errors?.required"
                            class="p-error">Template Name is Required </small>
                        <small
                            *ngIf="saveTemplateForm.get('template_name').touched && saveTemplateForm.get('template_name')?.invalid && saveTemplateForm.get('template_name')?.errors?.minlength"
                            class="p-error">Template Name should be minimum of 3
                            characters.</small>
                    </div>
                </form>
                <div class="m-2 mt-0 flex justify-content-end">
                    <button pButton label="CANCEL" class="cozmos-secondary-button p-button-sm ml-1"
                        (click)="saveTemplate.hide($event)"></button>
                    <button pButton label="SAVE" class="cozmos-primary-button p-button-sm ml-2"
                        (click)="onClickSaveTemplate(); saveTemplate.hide($event)"
                        [disabled]="saveTemplateForm.invalid"></button>
                </div>
            </ng-template>
        </p-overlayPanel>
        <hr class="break-line">
        <div class="p-fluid cozmos-filter-wrapper">
            <div class="cozmos-visible-filters">
                <div class="p-field filter-inputs" *ngFor="let col of grid_schema">
                    <label class="font font-color-dark" *ngIf="col?.is_filterable">{{col?.label}}</label>
                    <div [ngSwitch]="col?.filter_type" class="w-12" *ngIf="col?.is_filterable">
                        <span *ngSwitchCase="'dropdown'">
                            <p-dropdown [options]="col?.filter_options" optionLabel="name" optionValue="id"
                                styleClass="w-12" [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body">
                                <ng-template let-itm pTemplate="selectedItem">
                                    <div style="display: grid; grid-template-columns: auto 20% 20%;">
                                        <span style="text-align: left">{{itm.name}}</span>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </span>
                        <span *ngSwitchCase="'multiselect'">
                            <p-multiSelect [options]="col?.filter_options" optionLabel="name" optionValue="id"
                                styleClass="w-12" [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                [(ngModel)]="filterModel[col?.key]" [showClear]="true" appendTo="body">
                            </p-multiSelect>
                        </span>
                        <span *ngSwitchCase="'radiobutton'">
                            <div *ngFor="let category of col?.filter_options" class="w-12">
                                <p-radioButton [inputId]="category.value" name="category" [value]="category?.value"
                                    [(ngModel)]="filterModel[col?.key]"></p-radioButton>
                                <label [for]="category.value">{{category.name}}</label>
                            </div>
                        </span>
                        <span *ngSwitchCase="'calendar'">
                            <p-calendar appendTo="body" tooltipPosition="left" [(ngModel)]="filterModel[col?.key]"
                                [hideOnDateTimeSelect]="true" selectionMode="range" [showIcon]="true" showClear="true"
                                (ngModelChange)="onDateSelect($event, col?.key)" showButtonBar="true"
                                [readonlyInput]="true">
                            </p-calendar>
                        </span>
                        <span *ngSwitchDefault [pTooltip]="document?.[col.key]">
                            <input pInputText type="text" class="w-12"
                                [(ngModel)]="filterModel[col?.key.endsWith('_by') ? col.key.replace('_by', '_by_name') : col.key.endsWith('_to') ? col.key.replace('_to', '_to_by_name') : col.key]">
                            <!-- <input pInputText type="text" class="w-12"
                                [(ngModel)]="filterModel[col?.key.endsWith('_by') ? col.key.replace('_by', '_by_name') : col.key]"> -->
                            <!-- <input pInputText type="text" class="w-12" [(ngModel)]="filterModel[col?.key]"
                                (keyup.enter)="applyFilterSidebar()"> -->
                        </span>
                    </div>
                </div>
                <br>
                <!-- <h6 *ngIf="documentFieldList?.length>0">Document Attributes</h6>
                <br>
                <div class="p-field filter-inputs" *ngFor="let col of documentFieldList">
                    <label class="font font-color-dark">{{col?.label}}</label>
                    <div [ngSwitch]="col?.type" class="w-12">
                        <span *ngSwitchCase="'dropdown'">
                            <p-dropdown [options]="col?.filter_options" optionLabel="name" optionValue="id"
                                styleClass="w-12" [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                [(ngModel)]="filterModel?.data_elements[col.document_key]" [showClear]="true"
                                appendTo="body">
                                <ng-template let-itm pTemplate="selectedItem">
                                    <div style="display: grid; grid-template-columns: auto 20% 20%;">
                                        <span style="text-align: left">{{itm.name}}</span>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </span>
                        <span *ngSwitchCase="'multiselect'">
                            <p-multiSelect [options]="col?.filter_options" optionLabel="name" optionValue="id"
                                styleClass="w-12" [autoDisplayFirst]="false" [resetFilterOnHide]="true"
                                [(ngModel)]="filterModel?.data_elements[col.document_key]" [showClear]="true"
                                appendTo="body">
                            </p-multiSelect>
                        </span>
                        <span *ngSwitchCase="'multiselect_prvlg'">
                            <label class="fieldLabel">Role Privilege<span class="requiredField">*</span></label>
                            <p-multiSelect [options]="rolePrivilegeList" styleClass="w-12"
                                placeholder="Select privilege" optionLabel="name" formControlName="names"
                                optionValue="id" appendTo="body" resetFilterOnHide="true" [group]="true">
                                <ng-template let-group pTemplate="group">
                                    <div class="flex align-items-center" style="color: #001a29;">
                                        <span>{{group.module}}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                        </span>
                        <span *ngSwitchCase="'radiobutton'">
                            <div *ngFor="let category of col?.filter_options" class="w-12">
                                <p-radioButton [inputId]="category.value" name="category" [value]="category?.value"
                                    [(ngModel)]="filterModel?.data_elements[col.document_key]"></p-radioButton>
                                <label [for]="category.value">{{category.name}}</label>
                            </div>
                        </span>
                        <span *ngSwitchCase="'calendar'">
                            <p-calendar appendTo="body" dateFormat="yy-mm-dd" tooltipPosition="left"
                                [(ngModel)]="filterModel?.data_elements[col.document_key]" [hideOnDateTimeSelect]="true"
                                [showIcon]="true" showClear="true" showButtonBar="true"
                                (onSelect)="onDataElementDateSelect($event,col.document_key)" [readonlyInput]="true">
                            </p-calendar>
                        </span>
                        <span *ngSwitchDefault [pTooltip]="document?.[col.key]">
                            <input pInputText type="text" class="w-12"
                                [(ngModel)]="filterModel?.data_elements[col.document_key]">
                        </span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</p-sidebar>